import { createSlice } from "@reduxjs/toolkit";
import { startOfMonth } from "date-fns";
const initialState = {
    month: startOfMonth(new Date()),
    service: undefined,
};
const accountingSlice = createSlice({
    name: "accounting",
    initialState,
    reducers: {
        setMonth(state, action) {
            state.month = startOfMonth(action.payload);
        },
        setService(state, action) {
            state.service = action.payload;
        },
    },
});
export const { setMonth, setService } = accountingSlice.actions;
export default accountingSlice.reducer;
export const accountingSelector = (state) => state.accounting;
